import React from 'react';
import { trackClick } from 'src/api/metrics';

const Trackable = ({ children, trackId, click = true }) => {
  return <div onClick={() => click && trackClick(trackId)}>{children}</div>;
};

export default Trackable;
